<template>
  <div id="container">
    <div id="history">
      <div class="past-edition" v-for="(year,index) in years" :key="index">
        <div class="flag-pointer-container">
          <div class="flag-pointer" v-bind:class= "{teal: year.isTeal}"> {{year.title}} </div>
        </div>

        <div class="description-and-logo">
          <div class="description" v-text="year.content"></div>
          <div class="logo">
            <div class="image"><img :src ='year.image' ></div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      years: [
        { 
          title: 'Soft Skills Academy 5',
          content: 'Ultima ediție Soft Skills Academy a fost desfășurată în anul 2018 și a fost constituită din perioade de training session-uri organizate în două module: Personal Development & Career Development.Pe parcursul acestor training-uri, participanții au învățat să își dezvolte abilitățile de comunicare, leadership, negociere și au căpătat multe alte aptitudini importante în evoluția pe piața muncii. Pentru sedimentarea cunoștințelor învățate, aceștia au primit un Case Study la începutul evenimentului, urmând ca pe parcurs să găsească cea mai bună soluție, iar în ultima zi a evenimentului, să o prezinte în fața tuturor.',
          image: require("@/assets/images/Ssa5.png"),
          isTeal: false
        },
        {
          title: 'Soft Skills Academy 4',
          content: 'Soft Skills Academy 4 a avut loc in anul 2017 si a reunit o serie de training-uri organizate în două module: Personal Development &  Career Development, iar fiecare dintre aceste module a cuprins o serie de 5 training-uri. În cadrul acestora, participanții au învățat cât de importantă este fiecare etapă de pregătire pentru viitoarea carieră și cum să își canalizeze eforturile în așa fel încât să evolueze în profesia aleasă',
          image: require("@/assets/images/Ssa4.png"),
          isTeal: true
        },
        {
          title: 'Soft Skills Academy 3',
          content: 'Editia a 3-a a avut loc in anul 2015 si abordat o alta persectiva. Training session-uri au fost impărțite de această dată în 3 module diferite: Art Beyond Words, Conquering self-improvement, Career Visioning and Planning. Prin aceste training sessionuri, precum și prin discuțiile libere, studiile de caz, lucrul în echipă, aplicațiile practice, grupurile de reflecție și auto-evaluare, participanții au avut șansa de a interacționa și de a acumula cunoștințe într-un mediu non-formal',
          image: require("@/assets/images/Ssa3.jpg"),
          isTeal: false
        }
      ]
    };
  },
  methods: {
    getImage(url) {
      console.log(require(url));
      return require(url);
    }
  }
};
</script>

<style lang="scss" scoped>
#container{
  background-color: #0D2A4C;
  width: 100%;
  padding-bottom: 10vh;
  padding-top:30px;

}

#history {
  @extend %eestec-page;
  margin-left: 3%;
  border-left: 5px solid #FFFFFF;
  padding: 0px;

  
}

.past-edition{
  margin: 20px;
  margin-bottom: 10vh;
  margin-right: 0px;
  .flag-pointer-container{
    filter: drop-shadow(10px 10px 10px rgb(19, 18, 18));
    .flag-pointer{
      width: 30vw;
      height: 4.5vw;
      clip-path: polygon(0 0, 100% 0, 92% 50%, 100% 100%, 0 100%);
      background-color: #F37298;
      position: relative;
      right: 22px;

      text-align: center;
      vertical-align: middle;
      line-height: 4.5vw;
      font-size: 2vw;
      font-weight: bold;
      color: #edf6fb;
    }
    .isTeal{
      background-color: #0d9599;
    }
  }
  .description-and-logo{
    display: flex;
    flex-direction: row;
    margin-top: 7vh;
    margin-left: 5vh;

    .description{
      width: 55vw;
      // height: 18vw;
      font-size: calc(16px + (30 - 14) * ((100vw - 1024px) / (1920 - 1024)));
      
      color: #edf6fb;
      margin-right: 10%;

    }
    .logo{
      background-color: #F37298;
      border-radius: 25%;
      height: 18vw;
      width: 20vw;
      margin-top: auto;
      margin-bottom: auto;

      .image{
        width: 20vw;
        height: 18vw;
        background-color: #edf6fb;
        border-radius: 25%;
        position: relative;
        left: 2vw;
        filter: drop-shadow(10px 10px 10px rgb(19, 18, 18));
        img{
          width: 20vw;
          height: 18vw;
          border-radius: 25%;
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  #history{
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
  }
  .past-edition{

    .flag-pointer-container{
      width: 100%;
      .flag-pointer{
        width: 100%;
        height: 8vw;

      text-align: left;
      vertical-align: middle;
      line-height: 8vw;
      font-size: calc(14px + (26 - 14) * ((100vw - 300px) / (1024 - 300)));


      text-indent: 5vw;
      }
    }
    .description-and-logo{
      width: 100%;
      margin-left: 2vw;
      margin-top: 5vw;

      .description{
        width: 100%;
        margin-top: 1vw;
        font-size: calc(14px + (20 - 14) * ((100vw - 300px) / (1024 - 300)));
        

      }
      .logo{
        width: 0px;
        .image{
          width:0px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  #container {
      padding-top: 10vh;
  }
}

</style>
